const DICTIONARY = {
  accessToken: 't_access_token',
  user: 't_user',
};

export default DICTIONARY;
